import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

export interface AddAnotherBabyStepProps extends StepComponentProps {
  currentBabyIndex: number;
  maxBabies: number;
  onAddAnotherBaby: (addAnother: boolean) => void;
}

const AddAnotherBabyStep: React.FC<AddAnotherBabyStepProps> = ({
                                                                  formData,
                                                                  updateFormData,
                                                                  onNext,
                                                                  onPrevious,
                                                                  canGoBack,
                                                                  canGoNext,
                                                                  currentBabyIndex,
                                                                  maxBabies,
                                                                  onAddAnotherBaby,
                                                                }) => {
  const [addAnother, setAddAnother] = React.useState<boolean | null>(null);
  const babiesAdded = currentBabyIndex + 1;
  const canAddMore = babiesAdded < maxBabies;

  const handleSubmit = (event: any, values: any) => {
    if (addAnother !== null) {
      onAddAnotherBaby(addAnother && canAddMore);
    }
  };

  const handleAddAnotherChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    setAddAnother(value);
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-primary mb-3">Add Another Baby?</h6>
        <p className="text-muted mb-4">
          You have added {babiesAdded} baby{babiesAdded !== 1 ? 'ies' : ''} so far.
          {!canAddMore && ` (Maximum ${maxBabies} babies reached)`}
        </p>
        <AvForm onValidSubmit={handleSubmit}>
          <AvRadioGroup name="addAnotherBaby" required value={addAnother?.toString()}>
            <Row>
              <Col md="6">
                <Label className={`radio-button-label ${!canAddMore ? 'disabled' : ''}`}>
                  <AvRadio
                    name="addAnotherBaby"
                    value="true"
                    onChange={handleAddAnotherChange}
                    className="radio-button-input"
                    disabled={!canAddMore}
                  />
                  Yes, add another baby
                </Label>
              </Col>
              <Col md="6">
                <Label className="radio-button-label">
                  <AvRadio
                    name="addAnotherBaby"
                    value="false"
                    onChange={handleAddAnotherChange}
                    className="radio-button-input"
                  />
                  No, continue to additional details
                </Label>
              </Col>
            </Row>
          </AvRadioGroup>

          <FollowupButtons
            currentStep={12}
            totalSteps={13}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default AddAnotherBabyStep;
